import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getLoggedUser } from 'lib/reader'

// import Displayer from 'comp/Displayer'
import AppointmentSessionScreen from 'components/_Screens/AppointmentSession'

import { 
   getTelehealthAppointmentCredentials,
   clearTelehealthAppointmentCredentials,
   // getAndSelectAppointment
} from 'state/actions'

class AppointmentSessionContainer extends React.Component {

   constructor(props) {
      super(props)
      this.state = {
      }
      this.accessTeleHealthAppointment = this.accessTeleHealthAppointment.bind(this)
   }

   UNSAFE_componentWillMount() {
      // const { appointment, getAndSelectAppointment } = this.props

      // //if has no appointment, get appointment
      // if (!appointment) {
      //    const appointmentId = this.props.params.id ? this.props.params.id : null
      //    if (appointmentId) {
      //       getAndSelectAppointment(appointmentId)
      //    } else {
      //       this.context.router.push('/')
      //    }
      // }
   }

   componentWillUnmount() {
      const { clearTelehealthAppointmentCredentials } = this.props
      clearTelehealthAppointmentCredentials()
   }

   accessTeleHealthAppointment(appointmentId) {
      const { getTelehealthAppointmentCredentials } = this.props

      // Ask Telehealth credentials
      getTelehealthAppointmentCredentials(appointmentId)
   }

   render() {
      const { selectedAppointment: appointment, loggedUser: auth, ui, teleHealthAppointmentCredentials, clearTelehealthAppointmentCredentials } = this.props
      // if (!appointment) return <div style={{position:'relative', height: '100%', alignItems:'center', display:'flex',justifyContent:'center'}}><Displayer loading={true}/></div>
      return (

         <div style={{ height: '100%', width: '100%' }}>
            <AppointmentSessionScreen
               auth={auth}
               appointment={appointment}
               onAccessTeleHealthAppointment={this.accessTeleHealthAppointment}
               teleHealthAppointmentCredentials={teleHealthAppointmentCredentials}
               clearTelehealthAppointmentCredentials={clearTelehealthAppointmentCredentials}
               ui={ui}
            />
         </div>
      )
   }
}

AppointmentSessionContainer.propTypes = {
   selectedAppointment: PropTypes.object.isRequired, // appointment: PropTypes.object,
   loggedUser: PropTypes.object.isRequired, // auth: PropTypes.object.isRequired,
   teleHealthAppointmentCredentials: PropTypes.object,
   getTelehealthAppointmentCredentials: PropTypes.func.isRequired,
   clearTelehealthAppointmentCredentials: PropTypes.func.isRequired,
   // getAndSelectAppointment: PropTypes.func.isRequired,
   ui: PropTypes.object.isRequired,
}

// TeleHealthAppointmentContainer.contextTypes = {
//    router: PropTypes.object.isRequired,
// }

const mapStateToProps = (state) => ({
   loggedUser: getLoggedUser(state), // auth: state.auth,
   // appointment: state.appointments.selected,
   teleHealthAppointmentCredentials: state.data.teleHealthAppointmentCredentials,
   ui: state.ui,
})

export default connect(
   mapStateToProps,
   {
      getTelehealthAppointmentCredentials,
      clearTelehealthAppointmentCredentials,
      // getAndSelectAppointment,
   }
)(AppointmentSessionContainer)


// WEBPACK FOOTER //
// ./src/containers/AppointmentSession/index.js